
// SVG Icon: arrow-down
export default { id: "terriajs-arrow-down" };
export const id = "terriajs-arrow-down";
export const name = "arrow-down";
